import { removeTrapFocus, trapFocus } from '../storefront/globals';

class CartDrawerNote extends HTMLElement {
  constructor() {
    super();
    this.openBtnEl = this.querySelector('.js-cart-drawer-note-open');
    this.closeBtnEl = this.querySelector('.js-cart-drawer-note-close');
    this.summaryEl = this.querySelector('.js-cart-drawer-note-summary');

    this.addEventListener('keyup', (evt) => {
      if (evt.code === 'Escape') {
        evt.stopPropagation();
      }
    });

    this.openBtnEl.addEventListener('click', this.open.bind(this));

    this.closeBtnEl.addEventListener('click', this.close.bind(this));
  }

  open() {
    this.setActiveElement(this.openBtnEl);

    this.setAttribute('open', '');
    const isOpen = this.hasAttribute('open');
    this.openBtnEl.setAttribute('aria-expanded', isOpen.toString());

    this.addEventListener(
      'transitionend',
      () => {
        trapFocus(this.summaryEl);
      },
      { once: true },
    );
  }

  close() {
    this.removeAttribute('open');
    this.openBtnEl.setAttribute('aria-expanded', 'false');
    removeTrapFocus();

    setTimeout(() => {
      trapFocus(document.getElementById('CartDrawer'), this.summaryEl);
    });
  }

  closeFromOutside() {
    this.removeAttribute('open');
    this.openBtnEl.setAttribute('aria-expanded', 'false');
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer-note', CartDrawerNote);
